// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TYEIU","right":"styles_right__1T7dr"};